<template>
    <!-- 试听视频列表页面 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper CourseM">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>{{auditionTypeName}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    {{auditionTitle}}
                </div>
                <div class="ruleM">
                    <div class="rule flex-row pointer" v-for="(data, index) in dataList" :key="index"  @click="auditionVideoClick" :data-title="data.title" :data-url="data.videoUrl">
                        <div class="col-3">
                            <div class="point"></div>
                        </div>
                        <div class="col-75 text-left overflow pointer">
                            <Tooltip max-width="300" :content="data.title">
                                {{data.title}}
                            </Tooltip>
                        </div>
                        <div class="col-10 text-right date">
                            <!--07/06-->
                        </div>
                        <div class="col-10 text-center video">
                            <img src="../assets/video.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="pageM">
                    <Page :total="total" :current.sync="page" @on-change="pageClick"/>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Audition",
        data(){
            return {
                auditionTypeName: '', //试听课程类型名称
                auditionType : '', //试听课程类型名称
                auditionTitle:'',//试听课程名称
                total: 10,
                page: 1,
                dataList: []
            }
        },
        mounted(){
            this.getList();
            this.setTab();
        },
        methods: {
            pageClick(){
                console.log(this.page);
                this.getList();
            },
            getList(){
                var that = this;
                that.auditionType =  that.$route.params.auditionType;
                if(that.auditionType == 1){
                  that.auditionTypeName = '系统集成专业课程试听';
                }else {
                  that.auditionTypeName = '系统集成继续教育课程试听';
                }
                var modelData = {
                    "auditionId": that.$route.params.auditionId,
                    "page": that.page,
                    "size": "10"
                };
                this.$http({
                    url: that.webhost + 'audition/content/list',
                    method: 'POST',
                    data: modelData
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.dataList = data.data.list;
                        that.total = data.data.totalCount;
                        that.auditionTitle = data.data.auditionTitle
                    } else {
                        that.$Message.error(data.msg)
                    }
                })
            },
            auditionVideoClick(e){
              this.$store.commit('setAuditionTitle', e.currentTarget.dataset.title);
              this.$store.commit('setAuditionUrl', e.currentTarget.dataset.url);
              this.$router.push('/AuditionVideo');
            }
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 70px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .ruleM{
        padding: 20px 0;
        min-height: 400px;
        width: 95%;
        margin: auto;
    }
    .rule{
        font-size: 17px;
        height: 35px;
        line-height: 35px;
        position: relative;
    }
    .col-3{
        width: 3%;
    }
    .col-77{
        width: 77%;
    }
    .rule .point{
        width: 10px;
        height: 10px;
        background: #1a87cc;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
    }
    .date{
        color: #999;
    }
    .video img{
        width: 28px;
        height: 22px;
        position: relative;
        top: 4px;
        /*font-size: 30px;*/
    }
</style>

<style>
    .CourseM .ivu-page-item, .ivu-page-prev, .ivu-page-next{
        border-radius: 0;
    }
    .CourseM .ivu-page-item.ivu-page-item-active{
        background: #0070bd;
    }
    .CourseM .ivu-page-item-active a{
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/Audition.vue